import {
  Injectable,
  ApplicationRef,
  createComponent,
  EnvironmentInjector,
  ComponentRef,
  EmbeddedViewRef,
  inject,
  effect,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReopenParticipationDialogService } from '@sml/utility';

@Injectable({ providedIn: 'root' })
export class ReopenParticipationDialogLoaderService {
  private componentRef: ComponentRef<any> | null = null;

  private readonly appRef = inject(ApplicationRef);
  private readonly injector = inject(EnvironmentInjector);
  private readonly reopenParticipationDialogService = inject(ReopenParticipationDialogService);

  private isOpen = toSignal(this.reopenParticipationDialogService.isOpen$, { initialValue: false });

  constructor() {
    effect(() => {
      if (this.isOpen()) {
        this.loadComponent();
      } else {
        this.destroyComponent();
      }
    });
  }

  private async loadComponent(): Promise<void> {
    if (this.componentRef) return;

    const { ReopenParticipationDialogComponent } = await import(
      '../components/reopen-participation-dialog/reopen-participation-dialog.component'
    );

    this.componentRef = createComponent(ReopenParticipationDialogComponent, {
      environmentInjector: this.injector,
    });

    this.appRef.attachView(this.componentRef.hostView);

    const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  private destroyComponent(): void {
    if (!this.componentRef) return;

    const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    if (domElem?.parentNode) {
      domElem.parentNode.removeChild(domElem);
    }

    this.appRef.detachView(this.componentRef.hostView);
    this.componentRef.destroy();
    this.componentRef = null;
  }
}
